import { AURORA_TOUR_KEYS } from "./auroraTour";

/** Tour global de onboarding (Dashboard): bienvenida, panel, menú y resumen honesto. */
export const dashboardTourSteps = [
  {
    id: "program-bienvenida",
    brandHeader: true,
    title: "Bienvenida",
    text: "¡Bienvenido a Aurora Geriátrica! 🌅 Te guiaremos por lo esencial del panel en menos de un minuto.",
  },
  {
    id: "program-panel",
    title: "Panel principal",
    text: "Este es tu panel principal. Aquí verás un resumen de tus pacientes, alertas clínicas y actividad reciente.",
    attachTo: { element: '[data-aurora-tour="dashboard-main"]', on: "bottom" },
  },
  {
    id: "program-menu",
    title: "Menú de navegación",
    text: "Desde aquí accedes a todas las secciones de Aurora — Pacientes, Consultas, Agenda y Configuración.",
    attachTo: { element: '[data-aurora-tour="dashboard-nav"]', on: "right" },
  },
  {
    id: "program-resumen",
    title: "Lo que puedes hacer",
    text: "En el menú lateral encontrarás Pacientes, Consultas, Agenda y Configuración — cada sección tiene su propia guía interactiva cuando la visites por primera vez (evaluación geriátrica, informes PDF, personalización y exportación de datos).",
  },
  {
    id: "program-fin",
    brandHeader: true,
    title: "Fin del tour",
    text: "¡Listo! Ya conoces lo básico de Aurora. Si quieres repetir este recorrido puedes reiniciarlo desde Configuración. ¡Bienvenido al equipo! 🌅",
  },
];

export const consultaTourSteps = [
  {
    id: "consulta-guias",
    title: "Guías sugeridas",
    text: "Estas son las guías de evaluación sugeridas. Selecciona una para cargar un conjunto de escalas recomendadas según el objetivo clínico.",
    attachTo: { element: '[data-aurora-tour="consulta-guias"]', on: "bottom" },
  },
  {
    id: "consulta-escalas",
    title: "Escalas disponibles",
    text: "Aquí puedes ver y seleccionar todas las escalas clínicas disponibles — más de 26 validadas internacionalmente. Personaliza según tu paciente.",
    attachTo: { element: '[data-aurora-tour="consulta-escalas"]', on: "top" },
  },
  {
    id: "consulta-progress",
    title: "Progreso de la consulta",
    text: "Esta barra te muestra en qué paso vas y cuánto falta para completar la consulta.",
    attachTo: { element: '[data-aurora-tour="consulta-progress"]', on: "bottom" },
  },
  {
    id: "consulta-optional",
    title: "Pasos opcionales",
    text: "Verás este aviso en secciones opcionales. Puedes omitirlas si no son necesarias para tu paciente con el botón Omitir →",
    attachTo: { element: '[data-aurora-tour="consulta-nav"]', on: "top" },
  },
];

export const pdfTourSteps = [
  {
    id: "pdf-types",
    title: "Tipos de informe",
    text: "Aquí puedes generar diferentes tipos de informes — Informe clínico, Resumen familiar y Plan terapéutico. Todos se generan automáticamente en segundos.",
    attachTo: { element: '[data-aurora-tour="pdf-types"]', on: "bottom" },
  },
  {
    id: "pdf-download",
    title: "Descarga e impresión",
    text: "Descarga o imprime el informe directamente desde aquí para entregarlo al paciente o familia.",
    attachTo: { element: '[data-aurora-tour="pdf-download"]', on: "bottom" },
  },
];

export const personalizacionTourSteps = [
  {
    id: "personalizacion-clinica",
    title: "Perfil de clínica",
    text: "Aquí puedes personalizar Aurora con los datos de tu clínica — nombre, logo y firma médica.",
    attachTo: { element: '[data-aurora-tour="personalizacion-clinica"]', on: "bottom" },
  },
  {
    id: "personalizacion-logo",
    title: "Logo y firma",
    text: "Tu logo y firma aparecerán automáticamente en todos los informes PDF que generes.",
    attachTo: { element: '[data-aurora-tour="personalizacion-logo"]', on: "top" },
  },
  {
    id: "personalizacion-frases",
    title: "Frases personalizadas",
    text: "Agrega hasta 2 frases personalizadas que aparecerán en tus informes — ideal para tu slogan o información de contacto.",
    attachTo: { element: '[data-aurora-tour="personalizacion-frases"]', on: "top" },
  },
];

export const descargaTourSteps = [
  {
    id: "descarga-export",
    title: "Exportar datos",
    text: "Tus datos son 100% tuyos. Desde aquí puedes descargar toda tu base de datos — pacientes, consultas y evaluaciones — en cualquier momento.",
    attachTo: { element: '[data-aurora-tour="descarga-export"]', on: "bottom" },
  },
  {
    id: "descarga-formatos",
    title: "Formatos disponibles",
    text: "Descarga en formato CSV o Excel. Aurora no retiene ningún dato tuyo.",
    attachTo: { element: '[data-aurora-tour="descarga-formatos"]', on: "top" },
  },
];

export const TOUR_CONFIG = {
  dashboard: { key: AURORA_TOUR_KEYS.dashboard, steps: dashboardTourSteps },
  consulta: { key: AURORA_TOUR_KEYS.consulta, steps: consultaTourSteps },
  pdf: { key: AURORA_TOUR_KEYS.pdf, steps: pdfTourSteps },
  personalizacion: { key: AURORA_TOUR_KEYS.personalizacion, steps: personalizacionTourSteps },
  descarga: { key: AURORA_TOUR_KEYS.descarga, steps: descargaTourSteps },
};
